module.exports = __webpack_public_path__ + "static/media/IconoPila-mid.7eef0675.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/IconoPila-mid.svg
// module id = 116
// module chunks = 0